var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 34,
    fill: "#666666",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#666666"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 31C39 29.6739 38.4732 28.4021 37.5355 27.4645C36.5979 26.5268 35.3261 26 34 26C32.6739 26 31.4021 26.5268 30.4645 27.4645C29.5268 28.4021 29 29.6739 29 31C29 31.2652 29.1054 31.5196 29.2929 31.7071C29.4804 31.8946 29.7348 32 30 32C30.2652 32 30.5196 31.8946 30.7071 31.7071C30.8946 31.5196 31 31.2652 31 31C31 30.4067 31.1759 29.8266 31.5056 29.3333C31.8352 28.8399 32.3038 28.4554 32.8519 28.2284C33.4001 28.0013 34.0033 27.9419 34.5853 28.0576C35.1672 28.1734 35.7018 28.4591 36.1213 28.8787C36.5409 29.2982 36.8266 29.8328 36.9424 30.4147C37.0581 30.9967 36.9987 31.5999 36.7716 32.1481C36.5446 32.6962 36.1601 33.1648 35.6667 33.4944C35.1734 33.8241 34.5933 34 34 34C33.7348 34 33.4804 34.1054 33.2929 34.2929C33.1054 34.4804 33 34.7348 33 35V37C33 37.2652 33.1054 37.5196 33.2929 37.7071C33.4804 37.8946 33.7348 38 34 38C34.2652 38 34.5196 37.8946 34.7071 37.7071C34.8946 37.5196 35 37.2652 35 37V35.9C36.1294 35.6695 37.1444 35.0558 37.8733 34.1629C38.6022 33.27 39.0002 32.1527 39 31Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42C34.5523 42 35 41.5523 35 41C35 40.4477 34.5523 40 34 40C33.4477 40 33 40.4477 33 41C33 41.5523 33.4477 42 34 42Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.8d76a321c9f0e0bacb752ee105f0df60.svg";
export { ForwardRef as ReactComponent };